import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import Preloader from '@omilia/preloader';

import { Item } from 'tstypes';

import SearchResultItem from './components/SearchResultItem';

import { SNoResults, SResult } from './styled';

export interface Props {
  isLoaded: boolean;
  isLoading: boolean;
  value: string;
  items: Array<Item>;
  onSelect: (subUrl: string) => void;
}

class SearchResult extends Component<Props> {
  shouldComponentUpdate(
    nextProps: Pick<Props, 'value' | 'items' | 'isLoading'>,
  ) {
    return (
      nextProps.value !== this.props.value ||
      !isEqual(nextProps.items, this.props.items) ||
      nextProps.isLoading !== this.props.isLoading
    );
  }

  renderLoader() {
    if (this.props.isLoading) {
      return <Preloader data-test="spinner" />;
    }

    return null;
  }

  renderNoItems() {
    const { items, isLoaded, value } = this.props;

    if (isLoaded && !items.length) {
      return (
        <SNoResults data-test="no-results">
          No results found for {`"${value}"`}
        </SNoResults>
      );
    }

    return null;
  }

  render() {
    const { items, value, onSelect } = this.props;

    return (
      <SResult>
        {items.map(item => (
          <SearchResultItem
            key={item.id}
            item={item}
            value={value}
            onSelect={onSelect}
          />
        ))}
        {this.renderNoItems()}
        {this.renderLoader()}
      </SResult>
    );
  }
}

export default SearchResult;
